function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 26"
}, props), React.createElement("g", {
  clipPath: "url(#clip0_916_1485)"
}, React.createElement("path", {
  d: "M24.772 20.888L17.188 13l7.584-7.887A.834.834 0 0025 4.538a.834.834 0 00-.227-.574L21.19.238a.778.778 0 00-.553-.239.754.754 0 00-.552.239L12.5 8.125 4.917.238A.766.766 0 004.364 0a.766.766 0 00-.553.238L.23 3.964a.814.814 0 00-.23.574.84.84 0 00.23.575L7.813 13 .229 20.888a.83.83 0 00-.23.574.83.83 0 00.23.575l3.582 3.726a.778.778 0 00.553.239.753.753 0 00.552-.239l7.585-7.888 7.584 7.888a.767.767 0 00.552.238.766.766 0 00.552-.238l3.583-3.726a.814.814 0 00.23-.575.839.839 0 00-.23-.574z",
  fill: "#000"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_916_1485"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h25v26H0z"
})))));